import React from "react";
import { SubmitButton as Button } from "~/components/form/submit-button";

type SimpleDocument = {
  createddate: string;
  key: string;
  url: string;
};

type SimpleDocumentListProps = {
  documents: SimpleDocument[];
  isOpen: boolean;
  onClose: () => void;
};

const BulkUploadResultModal: React.FC<SimpleDocumentListProps> = ({
  documents,
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  const handleDownload = async (url: string, name: string) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = name;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const formatFileName = (key: string) => {
    return key.split("/").pop() || key;
  };

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleString(); 
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="fixed inset-0 bg-black opacity-50"></div>
      <div className="bg-white rounded-lg shadow-lg z-50 p-6 max-w-fit">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-lg font-semibold text-orange-500">Files</h3>
          <button
            onClick={onClose}
            className="text-orange-500 font-semibold px-4 py-2 rounded-md"
          >
            x
          </button>
        </div>

        <ul className="mb-4 max-h-[400px] overflow-y-auto pr-2">
          {documents.map((doc, index) => (
            <li
              key={index}
              className="flex justify-between items-center mb-3 space-x-4"
            >
              <div className="flex flex-col max-w-[500px]">
                <span className="text-sm font-medium truncate">
                  {formatFileName(doc.key)}
                </span>
                <span className="text-xs text-gray-500">
                  Created: {formatDate(doc.createddate)}
                </span>
              </div>
              <Button
                type="button"
                size="small"
                variant="secondary"
                onClick={() => handleDownload(doc.url, formatFileName(doc.key))}
              >
                Download
              </Button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BulkUploadResultModal;
